import React, {useState, useRef, useContext} from 'react';
import {
    AppBar,
    Box,
    Button,
    Divider,
    Drawer,
    IconButton,
    List,
    Toolbar,
    Hidden,
    Container,
    Slide,
} from '@material-ui/core';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import {Link, useRouteMatch} from 'react-router-dom';
import {HashLink} from 'react-router-hash-link';
import {LogoText, Logo} from 'components/icons/icons';
import AppsIcon from '@material-ui/icons/Apps';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import GroupIcon from '@material-ui/icons/Group';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import MenuIcon from '@material-ui/icons/Menu';
import BookIcon from '@material-ui/icons/Book';
import ListItemLink from 'components/ListItemLink';
import {AuthContext} from 'context/AuthContext';
import {makeStyles} from '@material-ui/core/styles';
import {drawerWidth} from 'components/ResponsiveNav';

function HideOnScroll(props) {
    const {children, window} = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({target: window ? window() : undefined});

    return (
        <Slide appear={false} direction='down' in={!trigger}>
            {children}
        </Slide>
    );
}

const useNavStyles = makeStyles(theme => ({
    drawerPaper: {
        width: drawerWidth,
        textAlign: 'center',
    },
    logo: {
        textAlign: 'center',
    },
    fixedAppBar: {
        width: '100%',
    },
    mainBar: {
        paddingLeft: '0',
        paddingRight: '0',
    },
}));

const LoggedOutNavBar = () => {
    const classes = useNavStyles();
    const domRef = useRef(); // This is to get rid of the error regarding findDomNode in React Strict Mode
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const toggleDrawer = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };
    const {logOut} = useContext(AuthContext);
    const match = useRouteMatch({
        path: '/signin',
    });

    return (
        <React.Fragment>
            <Drawer
                open={isDrawerOpen}
                onClose={toggleDrawer}
                classes={{
                    paper: classes.drawerPaper,
                }}
                ref={domRef}
            >
                <List>
                    <ListItemLink
                        primary={'Product'}
                        to={'/#product'}
                        key={'product'}
                        icon={<AppsIcon />}
                        onClick={toggleDrawer}
                    />
                    <ListItemLink
                        primary={'Pricing'}
                        to={'/#pricing'}
                        key={'pricing'}
                        icon={<LocalAtmIcon />}
                        onClick={toggleDrawer}
                    />
                    <ListItemLink
                        primary={'Contact'}
                        to={'/#contact'}
                        key={'contact'}
                        icon={<QuestionAnswerIcon />}
                        onClick={toggleDrawer}
                    />
                    <ListItemLink
                        primary={'Team'}
                        to={'/#team'}
                        key={'team'}
                        icon={<GroupIcon />}
                        onClick={toggleDrawer}
                    />
                    <Divider />
                    <ListItemLink
                        primary={'FAQs'}
                        to='/faqs'
                        key='faqs'
                        icon={<ContactSupportIcon />}
                        onClick={toggleDrawer}
                    />
                    <ListItemLink
                        primary={'Blog'}
                        href='/blog'
                        key='blog'
                        icon={<BookIcon />}
                        onClick={toggleDrawer}
                    />
                    <ListItemLink
                        primary={'Resources'}
                        to={'/resources'}
                        key={'resources'}
                        icon={<LibraryBooksIcon />}
                        onClick={toggleDrawer}
                    />
                    <ListItemLink
                        primary={'News Room'}
                        to={'/newsroom'}
                        key={'newsroom'}
                        icon={<LibraryBooksIcon />}
                        onClick={toggleDrawer}
                    />
                </List>
            </Drawer>
            <HideOnScroll>
                <AppBar position='fixed' className={classes.fixedAppBar}>
                    <Toolbar>
                        <Container maxWidth='xl' className={classes.mainBar}>
                            <Box display='flex' alignItems='center'>
                                <Box style={{flexShrink: 1}}>
                                    <IconButton
                                        color='inherit'
                                        aria-label='open drawer'
                                        edge='start'
                                        onClick={toggleDrawer}
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                </Box>
                                <Box flexGrow={1} className={classes.logo}>
                                    <HashLink smooth to='/#top'>
                                        <Hidden xsDown>
                                            <LogoText height='35' width='180' />
                                        </Hidden>
                                        <Hidden smUp>
                                            <Logo width='18' />
                                        </Hidden>
                                    </HashLink>
                                </Box>
                                {match?.path === '/signin' ? null : (
                                    <Box>
                                        <Link
                                            to='/signin'
                                            style={{textDecoration: 'none'}}
                                        >
                                            <Button
                                                variant='contained'
                                                color='secondary'
                                                data-cy='signin-header'
                                                onClick={logOut}
                                            >
                                                Sign In
                                            </Button>
                                        </Link>
                                    </Box>
                                )}
                            </Box>
                        </Container>
                    </Toolbar>
                </AppBar>
            </HideOnScroll>
        </React.Fragment>
    );
};

export default LoggedOutNavBar;
export {LoggedOutNavBar};
